import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Form, FloatingLabel, Button, Modal } from "react-bootstrap";
import { ButtonLoader } from "Components";
import { authService } from "Service/Axios";
import { WORKFLOWS_CREATE_FOLDER_API } from "Constant/api";
import { Validator } from "Utils/validator";
import { useRoleList } from "Constant/apiHooks";

export const CreateFolder = ({ show, toggle, fetchFolderList }) => {
    const { t } = useTranslation();

    const {
        roleList, loading: roleLoading, fetchRoleList
    } = useRoleList();

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        folderName: "",
        roleId: "",
    });
    const [errMsg, setErrMsg] = useState({
        folderName: "",
        roleId: "",
    });

    const { folderName, roleId } = formData;

    useEffect(() => {
        fetchRoleList();
    }, [])

    // On Change
    const handleChange = (e) => {
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
        if (e.target.name === "folderName") {
            if (!Validator.text(e.target.value)) {
                setErrMsg((prev) => ({
                    ...prev,
                    folderName: t("common.messages.error.common.folderName.blank"),
                }));
            } else {
                setErrMsg((prev) => ({
                    ...prev,
                    folderName: "",
                }));
            }
        }
        if (e.target.name === "roleId") {
            if (!Validator.text(e.target.value)) {
                setErrMsg((prev) => ({
                    ...prev,
                    roleId: t("common.messages.error.common.roleId.blank"),
                }));
            } else {
                setErrMsg((prev) => ({
                    ...prev,
                    roleId: "",
                }));
            }
        }
    };

    const getValidation = () => {
        return new Promise((resolve) => {
            if (Validator.text(folderName)) {
                resolve(true);
            } else {
                if (folderName && !Validator.text(folderName)) {
                    setErrMsg((prev) => ({
                        ...prev,
                        folderName: t("common.messages.error.common.folderName.blank"),
                    }));
                }
                resolve(false);
            }
        });
    };

    // On Submit
    const onSaveFolder = async () => {
        const validationStatus = await getValidation();
        if (validationStatus) {
            setLoading(true);
            try {
                const payload = {
                    name: folderName,
                    roles: roleList.map((role) => role.roleId),
                };
                const response = await authService(
                    WORKFLOWS_CREATE_FOLDER_API,
                    "POST",
                    payload
                );
                if (response) {
                    if (response.success) {
                        setLoading(false);
                        fetchFolderList();
                        toast.success(
                            t("common.messages.notification.success.createFolder")
                        );
                        toggle();
                    } else {
                        setLoading(false);
                        if (
                            response.message ===
                            "The folder is already exist. Please try another name."
                        ) {
                            toast.error(
                                t("common.messages.notification.failed.duplicateFolder")
                            );
                        } else {
                            toast.error(response.message);
                        }
                    }
                }
            } catch (error) {
                setLoading(false);
                if (error.response && error.response.data) {
                    toast.error(error.response.data.message);
                }
            }
        }
    };

    return (
        <Modal
            show={show}
            onHide={toggle}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header className="justify-content-center">
                <Modal.Title>{t("auth.formBuilder.createFolder")}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FloatingLabel
                    controlId="floatingInput"
                    label={t("common.label.folder")}
                    className="mb-3"
                >
                    <Form.Control
                        type="text"
                        placeholder={t("common.placeHolder.folderName")}
                        name="folderName"
                        value={folderName}
                        onChange={handleChange}
                    />
                    {errMsg.folderName && <p>errMsg.folderName</p>}
                </FloatingLabel>
                <FloatingLabel
                    controlId="floatingSelect"
                    label={t("common.label.folder")}
                    className="mb-3 grey-filed"
                >
                    <Form.Select
                        aria-label="Floating label select example"
                        name="roleId"
                        value={roleId}
                        onChange={handleChange}
                    >
                        <option value="">Select</option>
                        {!roleLoading &&
                            roleList &&
                            roleList.length > 0 &&
                            roleList.map((folder) => (
                                <option value={folder.gid}>{folder.name}</option>
                            ))}
                    </Form.Select>
                    {errMsg.roleId && <p className="error">{errMsg.roleId}</p>}
                </FloatingLabel>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={toggle}>
                    {t("common.button.cancel")}
                </Button>
                {!loading ? (
                    <Button variant="primary" onClick={onSaveFolder}>
                        {t("common.button.save")}
                    </Button>
                ) : (
                    <ButtonLoader />
                )}
            </Modal.Footer>
        </Modal>
    );
};
